import { Navigate} from 'react-router-dom'
import Layout from '../layouts/layout'

const ProtectRouteSuperAdmin = ()=>{
     
    const userData = JSON.parse(localStorage.getItem("userData"))

    return userData && userData.userRole === "SuperAdmin" ? <Layout/> : <Navigate to='/'/>
}
export default ProtectRouteSuperAdmin